module.exports = __webpack_public_path__ + "img/20-1.4547a308.png";